import { getAreaAcresFromPolygons, type PolygonRings } from "../../utils/area.js";

/** Undefined when the area of interest has no mapped boundary. */
export const getAreaAcres = (aoi: { polygons: PolygonRings }): number | undefined =>
    getAreaAcresFromPolygons(aoi.polygons);
